import React from 'react';
import { injectIntl } from 'react-intl';

import {
  Row,
  Col,
  Layout,
  Button,
} from 'antd';

import Nav from 'containers/Nav';
import AppHeader from 'containers/AppHeader';
import NavBottom from 'containers/NavBottom';
import NewProposalHeader from 'components/NewProposalHeader/NewProposalHeader';
import { CustomTextArea } from 'aplanet-ui-kit';


const Description = ({
  intl,
  values,
  handleChange,
  showError,
  next,
}) => {
  const t = intl.messages;

  return (
    <>
      <AppHeader />
      <Layout>
        <Nav />
        <Layout.Content>
          <NewProposalHeader
            stepCount={2}
          />
          <Row className="ProposalInitiative-description">
            <Col span={24} className="ProposalInitiative-heading">
              { t.proposal_description_title }
            </Col>
            <Col span={24} className="ProposalInitiative-textarea">
              <CustomTextArea
                placeholder={ t.proposal_description_placeholder }
                value={values.description}
                onChange={handleChange('description')}
              />
            </Col>
            <Col span={24}>
              { showError('description') }
            </Col>
          </Row>
          <Row className="ProposalInitiative-button-next">
            <Col span={24}>
              <Button
                type="primary"
                onClick={next}
              >
                { t.continue }
              </Button>
            </Col>
          </Row>
          <NavBottom />
        </Layout.Content>
      </Layout>
    </>
  );
};

export default injectIntl(Description);
